import { getOrElse } from "../../../src/_helpers/_utilities";

export const isAccentureBuild = getOrElse(() => process.env.BUILD_NAME === "ACN" || process.env.GATSBY_BUILD_NAME === "ACN", false);
